module.exports = __webpack_public_path__ + "static/media/Grupo1818.c06dee6f.svg";